import { get } from 'utils/api';

export const getDashboardData = (data) => {
  return get(`/dashboard`, data);
};

export const dashboard = {
  getDashboardData,
};
